import React from 'react';

import { cn } from '../../utils/bem';
import { usePropsHandler } from '../EventInterceptor/usePropsHandler';

import { ContentBuilderItem } from './ContentBuilderItem';
import { nanoid } from '@reduxjs/toolkit';
import { RoutePaths } from '../../../router';
import { IContent } from '../../../types/common';
import { IDictionariesForm } from '../Form/models';

export type BodyType = Record<
  string,
  string | number | boolean | null | undefined
>;

type Props = {
  items?: IContent[];
  aliases?: RoutePaths;
  dictionariesForm?: IDictionariesForm;
  onSubmitForm?: (body: BodyType) => Promise<any>;
  onSubmitFileForm?: (body: BodyType) => Promise<any>;
  CtaScrollerBtnLink?: string;
  pageId?: number | null;
  recaptchaKey?: string;
  titleTag?: 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6';
  studyCardBtnText?: string | undefined;
};

export const cnContentBuilder = cn('ContentBuilder');

export const ContentBuilder: React.FC<Props> = props => {
  const { items, aliases, ...otherProps } = usePropsHandler(
    cnContentBuilder(),
    props
  );

  return (
    <div className={cnContentBuilder()}>
      {items &&
        items.map(item => (
          <div className={cnContentBuilder('Item')} key={item.id || nanoid(6)}>
            <ContentBuilderItem {...item} aliases={aliases} {...otherProps} />
          </div>
        ))}
    </div>
  );
};

export { ContentBuilderItem } from './ContentBuilderItem';
